import { render } from "./VLotPartialList.vue?vue&type=template&id=4b50dd10"
const script = {}

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__